import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './AppShell';
import { OverviewPage } from '../features/overview/OverviewPage';
import { AuthStep } from '../features/onboarding/steps/AuthStep';
import { CnpjStep } from '../features/onboarding/steps/CnpjStep';
import { ProvidersStep } from '../features/onboarding/steps/ProvidersStep';
import { DemoStep } from '../features/onboarding/steps/DemoStep';
import { ApiKeyStep } from '../features/onboarding/steps/ApiKeyStep';
import {
  OnboardingStepGuard,
  RedirectIfAuthenticated,
  RequireCompletedOnboarding,
} from '../features/onboarding/guards';
import { LabelsPage } from '../features/labels/LabelsPage';
import { LabelDetailPage } from '../features/labels/LabelDetailPage';
import { TrackingPage } from '../features/tracking/TrackingPage';
import { ProvidersPage } from '../features/providers/ProvidersPage';
import { QuotesPage } from '../features/quotes/QuotesPage';
import { ApiKeysPage } from '../features/api-keys/ApiKeysPage';
import { RoutingPolicyPage } from '../features/routing/RoutingPolicyPage';
import { UsagePage } from '../features/usage/UsagePage';
import { CostsPage } from '../features/costs/CostsPage';
import { AddOrgPage } from '../features/orgs/AddOrgPage';

/**
 * App-wide routes (TTP-243/TTP-244). `/` is the post-onboarding dashboard
 * shell (`AppShell.tsx`, TTP-244 — replaces the TTP-255 stub, `App.tsx`,
 * previously mounted here) — every route funnels a user who hasn't finished
 * onboarding back to the right `/onboarding/*` step; see
 * features/onboarding/guards.tsx for the redirect rules.
 */
export function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <RequireCompletedOnboarding>
              <AppShell />
            </RequireCompletedOnboarding>
          }
        >
          <Route index element={<OverviewPage />} />
          <Route path="quotes" element={<QuotesPage />} />
          <Route path="labels" element={<LabelsPage />} />
          <Route path="labels/:labelId" element={<LabelDetailPage />} />
          <Route path="tracking" element={<TrackingPage />} />
          <Route path="providers" element={<ProvidersPage />} />
          <Route path="api-keys" element={<ApiKeysPage />} />
          <Route path="routing" element={<RoutingPolicyPage />} />
          <Route path="usage" element={<UsagePage />} />
          <Route path="costs" element={<CostsPage />} />
          <Route path="orgs/new" element={<AddOrgPage />} />
        </Route>

        <Route
          path="/signup"
          element={
            <RedirectIfAuthenticated>
              <AuthStep mode="signup" />
            </RedirectIfAuthenticated>
          }
        />
        <Route
          path="/login"
          element={
            <RedirectIfAuthenticated>
              <AuthStep mode="login" />
            </RedirectIfAuthenticated>
          }
        />

        <Route
          path="/onboarding/cnpj"
          element={
            <OnboardingStepGuard step="cnpj">
              <CnpjStep />
            </OnboardingStepGuard>
          }
        />
        <Route
          path="/onboarding/providers"
          element={
            <OnboardingStepGuard step="providers">
              <ProvidersStep />
            </OnboardingStepGuard>
          }
        />
        <Route
          path="/onboarding/demo"
          element={
            <OnboardingStepGuard step="demo">
              <DemoStep />
            </OnboardingStepGuard>
          }
        />
        <Route
          path="/onboarding/api-key"
          element={
            <OnboardingStepGuard step="api-key">
              <ApiKeyStep />
            </OnboardingStepGuard>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
